/*
 * @Description: 数据分析有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  分配线索数: 'Assigned Clue Count',
  飞书: 'Feishu',
  图表: 'Chart',
  表格: 'Table',
  数据概览: 'Data overview',
  动态记录数: 'Follow-up record count',
  外呼接通数: 'Outgoing call connection count',
  日程数: 'Schedule count',
  线索总数: 'Total Clue Count',
  超2日待处理: 'Awaiting processing over 2 days',
  走势图: 'Trend chart',
  默认规则展示: 'Default rule display',
  按日展示: 'Daily display',
  按周展示: 'Weekly display',
  按月展示: 'Monthly display',
  待处理线索数量: 'Pending clue count',
  状态分布: 'Status Distribution',
  线索及时跟进率: 'Clue Timely Follow-up Rate',
  客户发展阶段分布: 'Customer development stage distribution',
  客户一级行业分布: 'Customer primary industry distribution',
  客户二级行业分布: 'Customer secondary industry distribution',
  客户地域分布: 'Customer geographic distribution',
  客户规模分布: 'Customer scale distribution',
  区域指标对比: 'Regional indicator comparison',
  个人指标对比: 'Individual indicator comparison',
  个人指标报表: 'Individual indicator report',
  客户行业分布: 'Distribution of customer industries',
  二级行业: 'Secondary industry',
  排名: 'Ranking',
  客户数: 'Number of customers',
  占比: 'Percentage',
  省份: 'Province',
  城市: 'City'
};
